(function () {
  'use strict';

  function markPage() {
    if (!document.body) return;
    document.body.classList.add('shabima-landing-v1-page', 'shabima-alumbre-v1-page');
    if (window.location.pathname === '/products_preview') {
      document.body.classList.add('alv1-preview-only');
    }
  }

  function keepSingleReleasitButton() {
    var buttons = document.querySelectorAll('._rsi-buy-now-button-product');
    if (buttons.length < 2) return;
    Array.prototype.slice.call(buttons, 1).forEach(function (button) {
      button.remove();
    });
  }

  function hideNativePurchaseControls() {
    document.querySelectorAll(
      '.product-form__submit:not([id*="_rsi"]):not([class*="_rsi"]), ' +
      'form[action*="/cart/add"] button[type="submit"]:not([id*="_rsi"]):not([class*="_rsi"]), ' +
      '.shopify-payment-button, .shopify-payment-button__more-options'
    ).forEach(function (node) {
      node.style.setProperty('display', 'none', 'important');
    });

    document.querySelectorAll('button[id*="_rsi"], button[class*="_rsi"]').forEach(function (node) {
      node.style.setProperty('display', 'flex', 'important');
      node.style.setProperty('visibility', 'visible', 'important');
      node.style.setProperty('opacity', '1', 'important');
      node.style.setProperty('pointer-events', 'auto', 'important');
    });

    keepSingleReleasitButton();
  }

  function guardReleasitInitializer(rsi) {
    var productPage = rsi && rsi.productPage;
    if (!productPage || productPage.__alumbreSingleMountGuard) return;
    if (typeof productPage.initFeatures !== 'function') return;

    var originalInitFeatures = productPage.initFeatures.bind(productPage);
    productPage.initFeatures = function () {
      if (document.querySelector('._rsi-buy-now-button-product')) {
        keepSingleReleasitButton();
        return;
      }
      var result = originalInitFeatures.apply(productPage, arguments);
      keepSingleReleasitButton();
      return result;
    };
    productPage.__alumbreSingleMountGuard = true;
  }

  function ensureReleasitMount() {
    var waited = 0;
    var timer = window.setInterval(function () {
      waited += 1;
      var rsi = window._rsi;
      var cache = document.querySelector('#rsi-cod-form-product-cache');

      if (rsi && rsi.productPage) {
        guardReleasitInitializer(rsi);
      }

      if (document.querySelector('._rsi-buy-now-button-product')) {
        keepSingleReleasitButton();
        window.clearInterval(timer);
        return;
      }

      if (rsi && cache && rsi.productPage &&
          typeof rsi.productPage.getProductJson === 'function' &&
          typeof rsi.productPage.initFeatures === 'function') {
        rsi.productPage.getProductJson();
        if (rsi.productPage.productJson) {
          rsi.productPage.initFeatures();
          keepSingleReleasitButton();
          window.clearInterval(timer);
        }
      }

      if (waited >= 40) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function prepareVideo() {
    var video = document.querySelector('[data-alumbre-use-video]');
    if (!video) return;

    if (!('IntersectionObserver' in window)) {
      video.play().catch(function () {});
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '180px 0px', threshold: 0.08 });
    observer.observe(video);
  }

  function init() {
    markPage();
    hideNativePurchaseControls();
    ensureReleasitMount();
    prepareVideo();

    if (document.body) {
      new MutationObserver(hideNativePurchaseControls).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    window.addEventListener('pageshow', function () {
      keepSingleReleasitButton();
    });
  }

  markPage();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
